(function () {
    "use strict";

    angular
        .module("app")
        .component("customerDropdown", { // customer-dropdown
            templateUrl: "src/app/customerDropdown/customerDropdown.html",
            controller: controller,
            bindings: {
                selectedCustomerId: "<",
                selectedCompanyName: "<",
                onCustomerSelected: "&"
            }
        });

    function controller(session) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.customer = null;

        // customer dropdown
        $ctrl.customers = [...session.user.customers].orderBy("company_name");
        if ($ctrl.customers.length > 1) {
            $ctrl.customers.unshift({ customer_id: null, company_name: "Any Customer" });
        }

        $ctrl.$onChanges = () => {
            if (!session.user.is_admin)
                $ctrl.customer = $ctrl.customers.find(c => c.customer_id === $ctrl.selectedCustomerId);
            else if ($ctrl.selectedCompanyName && $ctrl.selectedCustomerId !== ($ctrl.customer || {}).customer_id) {
                // if customer is passed in, and different from what is currently selected...
                $ctrl.search($ctrl.selectedCompanyName).then(customers => {
                    $ctrl.customer = customers.find(c => c.customer_id === $ctrl.selectedCustomerId);
                });
            }
        };

        // customer search for admin users
        $ctrl.search = company_name => session.customers.search(company_name);

        $ctrl.isCustomerTextValid = () => {
            // When a customer is selected, $ctrl.customer will be the object selected,
            // otherwise it will just be a string of whatever the user has typed.
            // It is valid if nothing is selected, or a product object is selected
            return $ctrl.customer == null || $ctrl.customer.length === 0 || typeof $ctrl.customer === "object";
        };

    }
    controller.$inject = ["sessionService"];

})()